import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import usersReducer from './slices/usersSlice';
import exercisesReducer from './slices/exercisesSlice';
import equipmentReducer from './slices/equipmentSlice';
import notificationReducer from './slices/notificationsSlice';
import programReducer from './slices/programSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    users: usersReducer,
    exercises: exercisesReducer,
    equipment: equipmentReducer,
    notification: notificationReducer,
    program: programReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
